export function composeTestIDs(rootID, ...childrenIDs: string[]) {
  return rootID ? [rootID, ...childrenIDs].join('.') : undefined;
}
